module.exports = __webpack_public_path__ + "static/media/default.ad04c91f.jpg";